import React from "react";
import { Box, Group, Drawer, Button, SegmentedControl, Paper, Text, useMantineTheme, Select, ActionIcon } from '@mantine/core';
import { IconChevronRight, IconX, IconArrowLeft } from '@tabler/icons-react';

import { utils } from "../../utils/globalVariables";
import InputWrapperCustom from "../../components/general/InputWrapperCustom";
import ActionIconComponent from "../../components/general/ActionIconComponent";
import StockCategorySelectorDrawer from "../../components/utilities/StockCategorySelectorDrawer";

const StockCategorySubFilter = ({
    stateShow,
    fnShow,
    stateDefaultFilter,
    stateFilter,
    fnFilter
}) => {

    const theme = useMantineTheme();

    const [data, setData] = React.useState({
        filterCategory: stateFilter.filterStockCategory,
        filterStockActual: stateFilter.filterStockCategorySubStockActual,
        filterIsActive: stateFilter.filterStockCategorySubIsActive,
    });

    const handleFilter = () => {
        fnFilter(
            data.filterCategory.id,
            data.filterStockActual,
            data.filterIsActive,
        )
    }

    const handleReset = () => {
        setData(d => ({
            ...d,
            filterCategory: stateDefaultFilter.stockCategory,
            filterStockActual: stateDefaultFilter.stockCategorySubStockActual,
            filterIsActive: stateDefaultFilter.stockCategorySubIsActive,
        }))
    }

    return (
        <React.Fragment>
            <Drawer
                opened={stateShow}
                onClose={fnShow}
                withCloseButton={false}
                position="left"
                closeOnClickOutside={true}

                title={
                    <Group noWrap spacing='xs'>
                        <ActionIcon
                            size='lg'
                            variant="light"
                            radius='xl'
                            color="blue"
                            onClick={fnShow}
                        >
                            <IconArrowLeft size='1.25rem' stroke={1.5} />
                        </ActionIcon>

                        <Text>Filter Sub Kategori</Text>
                    </Group>
                }
                size='md'

                styles={() => ({
                    title: {
                        fontWeight: 'bold',
                        textTransform: 'uppercase'
                    }
                })}
            >
                <Box py='md'>

                    <Box mb='2rem'>
                        <InputWrapperCustom
                            stateLabel='Kategori'
                            stateWithAsterisk={false}
                        >
                            <Paper
                                sx={(tema) => ({
                                    backgroundColor: tema.colorScheme === 'light' ? '#fff' : tema.colors.dark[6],
                                    borderWidth: '1px',
                                    borderStyle: 'solid',
                                    borderColor: tema.colorScheme === 'light' ? tema.colors.gray[4] : tema.colors.dark[4],
                                    cursor: 'pointer',
                                })}

                                onClick={() => {
                                    setData(d => ({
                                        ...d,
                                        filterCategory: {
                                            ...d.filterCategory,
                                            show: true
                                        }
                                    }));
                                }}
                            >
                                {data.filterCategory.id === utils.flagAll &&
                                    <Group
                                        noWrap
                                        p="xs"
                                    >
                                        <Text size='sm'>Semua Kategori</Text>
                                        <IconChevronRight size="1rem" />
                                    </Group>
                                }

                                {data.filterCategory.id && (data.filterCategory.id !== utils.flagAll) &&
                                    <Group
                                        position="apart"
                                        noWrap
                                        p="xs"
                                    >
                                        <Group noWrap>
                                            <Text size='sm'>
                                                <Text>
                                                    {data.filterCategory.name}
                                                </Text>

                                                <Text size='xs'>
                                                    {data.filterCategory.isActive === '1' ? 'Aktif' : 'Non Aktif'}
                                                </Text>
                                            </Text>
                                        </Group>

                                        <ActionIconComponent
                                            stateVariant='light'
                                            stateRadius='xl'
                                            stateTitle='Hapus'
                                            stateSize='lg'
                                            fnOnClick={(e) => {
                                                e.stopPropagation();

                                                setData(d => ({
                                                    ...d,
                                                    filterCategory: stateDefaultFilter.stockCategory
                                                }))
                                            }}

                                            StateIcon={IconX}
                                            stateIconSize='1.125rem'
                                            stateIconStrokeWidth={1.25}
                                            stateIconStyle={{
                                                color: theme.colorScheme === 'light' ? '#000' : theme.colors.gray[0]
                                            }}
                                        />
                                    </Group>
                                }
                            </Paper>
                        </InputWrapperCustom>
                    </Box>

                    <Box mb='2rem'>
                        <InputWrapperCustom
                            stateLabel='Stok'
                            stateWithAsterisk={false}
                        >
                            <Select
                                value={data.filterStockActual}
                                onChange={(val) => {
                                    setData(d => ({ ...d, filterStockActual: val }))
                                }}
                                data={[
                                    { value: utils.flagAll, label: 'Semua' },
                                    { value: 'less-than-equal', label: 'Dibawah/Sama Dengan Stok Minimal' },
                                    { value: 'greater-than', label: 'Diatas Stok Minimal' },
                                ]}
                            />
                        </InputWrapperCustom>
                    </Box>

                    <Box mb='2rem'>
                        <InputWrapperCustom
                            stateLabel="Status Sub Kategori"
                            stateWithAsterisk={false}
                            stateError=''
                            stateDescription=''
                        >
                            <SegmentedControl
                                fullWidth
                                value={data.filterIsActive}
                                onChange={(val) => setData(d => ({ ...d, filterIsActive: val }))}
                                data={[
                                    { label: 'Semua', value: utils.flagAll },
                                    { label: 'Aktif', value: '1' },
                                    { label: 'Non Aktif', value: '0' },
                                ]}
                            />
                        </InputWrapperCustom>
                    </Box>

                    <Group position="apart" noWrap spacing='xs' my='xl'>
                        <Button
                            fullWidth
                            variant="default"
                            color='gray'
                            onClick={handleReset}
                        >
                            Reset
                        </Button>

                        <Button
                            fullWidth
                            color='teal'
                            onClick={handleFilter}
                        >
                            Filter
                        </Button>
                    </Group>
                </Box>
            </Drawer>

            <StockCategorySelectorDrawer
                stateShow={data.filterCategory.show}

                fnShow={() => setData(d => ({
                    ...d,
                    filterCategory: {
                        ...d.filterCategory,
                        show: false
                    }
                }))}

                fnOnSelect={(id, name, isActive) => setData(d => ({
                    ...d,
                    filterCategory: {
                        ...d.filterCategory,
                        id: id,
                        name: name,
                        isActive: isActive,
                        show: false,
                    }
                }))}
            />
        </React.Fragment>
    )
}

export default StockCategorySubFilter;